import React from 'react'
import { PurchaseBulletProps } from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/PurchasesSection/components/PurchaseBullet/PurchaseBullet.types'
import NiceModal from '@ebay/nice-modal-react'
import GiftDetailsDrawer from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/GiftDetailsDrawer'
import ReservationBullet from '../../../ReservationBullet/ReservationBullet'

const PurchaseBullet: React.FC<PurchaseBulletProps> = ({
  regItem,
  reservation,
  totalReservationQuantity,
}) => {
  const handleOpenGiftDetails = () => {
    NiceModal.show(GiftDetailsDrawer, { reservationToken: reservation.token })
  }

  let quantityString: string | undefined
  if (totalReservationQuantity !== 1 || regItem.quantity !== 1) {
    quantityString = `Qty ${reservation.quantity}`
  }

  return (
    <ReservationBullet
      isSurprise={
        reservation.isSurprise && !reservation.isSurpriseRevealedForUser
      }
      name={reservation.name}
      quantity={quantityString}
      onViewGift={handleOpenGiftDetails}
    />
  )
}

export default PurchaseBullet
